import type { AddressDetailsDto } from '@up2stay/up2promo-api-client';

import type { LocationAddressDetails } from '@/core/components/locations/location-details-form';

export function toAddressDetailsDto(
  details: LocationAddressDetails,
): AddressDetailsDto {
  const out: AddressDetailsDto = {};
  if (details.formatted != null) out.formatted = details.formatted;
  if (details.postalCode != null) out.postalCode = details.postalCode;
  if (details.street != null) out.street = details.street;
  if (details.streetNumber != null) out.streetNumber = details.streetNumber;
  if (details.locality != null) out.locality = details.locality;
  if (details.administrativeArea != null) {
    out.administrativeArea = details.administrativeArea;
  }
  if (details.administrativeAreaLevel2 != null) {
    out.administrativeAreaLevel2 = details.administrativeAreaLevel2;
  }
  if (details.country != null) out.country = details.country;
  if (details.countryCode != null) out.countryCode = details.countryCode;
  return out;
}

export function hasAddressContent(
  details: LocationAddressDetails | null,
): boolean {
  if (!details) return false;
  return Object.values(details).some(
    (value) => typeof value === 'string' && value.trim().length > 0,
  );
}
